import { EHelpCenterType } from '@portals/help-center-core';
import { useClientSearchParams } from '@/_hooks/use-client-search-params';
import { getIsSideMode, getHelpCenterType } from '@/_utils';

export const useHelpCenterType = (): EHelpCenterType => {
  const searchParams = useClientSearchParams();
  const isSideMode = getIsSideMode(searchParams);

  return getHelpCenterType(isSideMode);
};
